import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';

const ServiceCards = () => {
  const { requestService } = useContext(AppContext);
  const services = [
    { id: 'insurance', icon: 'fa-shield-alt', label: 'Insurance' },
    { id: 'finance', icon: 'fa-wallet', label: 'Finance' },
    { id: 'service', icon: 'fa-tools', label: 'Service & Maintenance' },
    { id: 'inspection', icon: 'fa-search', label: 'Inspection' },
  ];

  return (
    <>
      <div style={{ margin: '4px 0 2px', display: 'flex', alignItems: 'center', gap: 5 }}>
        <i className="fas fa-concierge-bell" style={{ color: '#0f5b7a', fontSize: 14 }} />
        <span style={{ fontWeight: 500, color: '#1f4d66', fontSize: 13 }}>Services</span>
      </div>
      <div className="service-strip">
        {services.map((service) => (
          <button
            key={service.id}
            type="button"
            className="service-card"
            onClick={() => requestService({ applicationType: service.id })}
          >
            <i className={`fas ${service.icon}`} /> {service.label}
          </button>
        ))}
      </div>
    </>
  );
};

export default ServiceCards;
